import React, {useMemo} from "react";
import {useHistory} from "react-router-dom";

import "./product-card.scss";
import showPrice from "utils/show-price";
import MyRouterUtil from "utils/MyRouterUtil";
import {getGoodsType} from "utils/GoodsTypeUtil";

function ProductCard(props) {
    const history = useHistory();
    let {
        id,
        name,
        originPrice,
        currentPrice,
        shopId,
        soldNum,
        mainPic,
        hasCollect,
        collectId,
        categoryId,
        isHot,
        isNew,
        isSpecialPrice,
        serviceTags,
        mallName,
        pddShop,
        isPddShop,
        isJdShop,
        className
    } = props;

    const goodsType = useMemo(() => {
        return getGoodsType({isPddShop, isJdShop});
    }, [isPddShop, isJdShop])


    const toGoodsInfo = ({goodsType, id}) => {
        MyRouterUtil.build({history}).toGoodsInfo({goodsType, id})
    }

    return (
        <div
            className={`glx-home-random-product-card ${className}`}
            onClick={() => {
                toGoodsInfo({id, goodsType});
            }}
        >
            <div className="img-block">
                <img src={mainPic} alt="" className="img"/>
            </div>
            <div className="info-block">
                <div className="name-floor">{name}</div>
                <div className="price-floor">
                    <div className="current-price">{showPrice(currentPrice)}</div>
                    {!pddShop && <div className="self">自营</div>}
                    {isHot === 1 && <div className="hot">热卖</div>}
                </div>
            </div>
        </div>
    );
}

export default ProductCard;
